import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogOverviewExampleDialogComponent } from '../../dialog-overview-example-dialog/dialog-overview-example-dialog.component';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';
// import { async } from '@angular/core/testing';

@Component({
  selector: 'app-client-list',
  templateUrl: './client-list.component.html',
  styleUrls: ['./client-list.component.scss']
})
export class ClientListComponent implements OnInit {
  public imageBaseV2Url = BaseUrlConstantsService.NEW_IMAGE_RELATIVE_BASE_URL;
  public imageUploadUrl = BaseUrlConstantsService.IMAGE_UPLOAD;
  public deleteUserUrl = BaseUrlConstantsService.DELETE_USERS;
  public imageBaseUrl = BaseUrlConstantsService.IMAGE_RELATIVE_URL;
  public managerClientListingUrl = BaseUrlConstantsService.MANAGER_CLIENT_LIST;
  public pid: boolean;
  public showList: boolean;
  public emptyMsg: boolean;
  public checked = false;
  public clientList: any;
  public showSentMessage: boolean;
  public selectValueArr: any = [];
  public allClients: any = [];
  public showEmptyError: any = '';
  selectedClientIDsArr: any = [];
  public breadcrumbsArray: any = [{
    page_ref: '/manager-client-list',
    page_title: 'Manager clients'
  }];
  public classAdd: any;

  constructor(
    private changeService: ChangeUsersService,
    public router: Router,
    private service: BackendApiService,
    private activeRoute: ActivatedRoute,
    public dialog: MatDialog) {
    this.showSentMessage = true;
  }


  showDeleteDialog(id, index) {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '400px',
      height: '150px',
      data: {
        type: 'delete-dialog-open',
        typeOf: 'user'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        this.deleteUser(id, index);
      }
    });
  }

  seeUserAssets(userId, userName) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        admin_client_id: userId,
        clientName: userName,
        pageRef: 'siteInchargeAssets'
      }
    };
   this.router.navigate(['/device-report-new'], navigationExtras);
  }


  deleteUser(user_id, index) {
    this.service.deleteInfo(this.deleteUserUrl + "/" + user_id).then(res => {
      if (JSON.parse(JSON.stringify(res)).message.includes("successfully deleted")) {
        this.classAdd = index;
        this.service.showSuccess('Successfully deleted.');
        this.allClients.splice(index, 1);
        if (this.allClients.length === 0) {
          this.showList = false;
          this.emptyMsg = true;
        }
      } else {
        this.service.showSuccess('Something went wrong.');
      }
    });
  }


  goToPageLink(name: string) {
    this.router.navigate([name]);
  }

  async selectListItem(event: any, index: number, id: number) {
    if (event.checked) {
      this.selectValueArr.push(id);
    } else {
      this.selectValueArr.splice(index, 1);
    }
    this.selectedClientIDsArr = Array.from(new Set(this.selectValueArr));
  }

  trackByFn(index, item) {
    return item.id;
  }

  ngOnInit() {
    this.getAllClients();
  }
  sentMessage(): void {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '650px',
      data: {
        type: 'viewSentmsg',
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  getAllClients() {
    this.changeService.loader(true);
    this.service.getData(this.managerClientListingUrl + "/" + localStorage.getItem("user_id")+"?role=SITE_INCHARGE").then(async (res) => {
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        this.clientList = JSON.parse(JSON.stringify(res)).data.body;
        if (this.clientList.length !== 0) {
          this.showList = true;
          this.emptyMsg = false;
          for (var i = 0; i < this.clientList.length; i++) {
            await this.service.getData(this.imageUploadUrl + "/" + parseInt(this.clientList[i].id)).then(async response => {
              if (JSON.parse(JSON.stringify(response)).data.body.length !== 0) {
                this.clientList[i].profile_image = this.imageBaseV2Url+'uploads/'+ JSON.parse(JSON.stringify(response)).data.body[0].relative_url;
              }
            });
          }
          this.changeService.loader(false);
          this.allClients = await this.clientList;
        } else {
          this.showList = false;
          this.emptyMsg = true;
        }
      } else {
        this.changeService.loader(false);
        this.showList = false;
        this.emptyMsg = true;
        this.service.showError('Something went wrong.');
      }
    }, err => {
      this.changeService.loader(false);
    });


  }


  searchData(ev) {
    const term = ev.toLowerCase();
    this.allClients = this.clientList.filter(tag => tag.company_name.toLowerCase().indexOf(term) >= 0 || tag.country.toLowerCase().indexOf(term) >= 0 || tag.industry_type.toLowerCase().indexOf(term) >= 0   || tag.state.toLowerCase().indexOf(term)>=0);
    if (this.allClients.length === 0) {
      this.showEmptyError = 'No Results';
    } else {
      this.showEmptyError = '';
    }
  }

  // searchData(ev) {
  //   const term = ev.toLowerCase();
  //   this.allClients = this.clientList.filter(
  //     tag => tag.full_name.toLowerCase().indexOf(term) >= 0 || tag.email.toLowerCase().indexOf(term) >= 0);
  //   if (this.allClients.length === 0) {
  //     this.showEmptyError = 'No Results';
  //   } else {
  //     this.showEmptyError = '';
  //   }
  // }

  async addClients() {
    this.router.navigate(['/add-client']);
  }

  async editClient(id) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        adminClientId: id,
        pid: true,
        pageRef: 'admin-client'
      }
    };
    this.router.navigate(['/add-client'], navigationExtras);
  }


  async showLicense() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: '650px',
      data: {
        type: 'adminLicense'
      }
    });
  }
}
